export default {
  SET_QUERY(state, value) {
    state.query = value.toLowerCase();
    state.originalQuery = value;
  },
  SET_SELECTED_FILTER(state, value) {
    state.selectedFilter = value;
  },
};
